'use strict';
import {AudioConferenceController} from "../index";

import {mapState, mapActions} from "vuex";
import ConferenceStatusView from "./view";

export default {
    render: () => null,

    data() {
        return {
            dimension: {
                width: 300,
                height: 180,
            },

            nonVRLocation: {
                top: 190,
                right: 1
            },

            VRLocation: {
                bottom: 1,
                left: 1
            }
        }
    },

    computed: {
        ...mapState('audioConference', [
            'userIds', 'isConferenceEnabled'
        ]),

        userDetails: function () {
            return this.userIds.map(id => {
                return {
                    id: id,
                    name: getNameFromUserID(id.toString()),
                    imagePath: getImagePathFromUserID(id.toString())
                }
            });
        },

        getConferenceStatus: function () {
            return this.isConferenceEnabled;
        }
    },

    methods: {
        ...mapActions('audioConference', {
            addUser: 'add',
            removeUser: 'remove',
            updateConferenceStatus: 'updateConferenceStatus'
        }),

        updateCanvasLocation() {
            if (!isVRModeEnabled()) {
                this.view.setLocation(this.nonVRLocation, this.dimension);
            } else {
                this.view.setLocation(this.VRLocation, this.dimension);
            }
        }
    },

    watch: {
        userDetails: async function () {
            const params = {
                location: isVRModeEnabled() ? this.VRLocation : this.nonVRLocation,
                dimension: this.dimension,
                userDetails: this.userDetails
            };

            await this.view.createCanvas(params);
        },

        getConferenceStatus: function () {
            if (!this.isConferenceEnabled) {
                this.view.dispose();
            }
        }
    },

    created: function () {
        AudioConferenceController.setFeature(this);

        const params = {
            location: isVRModeEnabled() ? this.VRLocation : this.nonVRLocation,
            dimension: this.dimension,
            userDetails: this.userDetails
        };

        this.view = new ConferenceStatusView(params);
    },

    destroyed: function () {
        this.view.dispose();
    }
};
